import * as z from "zod/v4";

export const undoCatalogAgentOperation = {
  name: "undoCatalogAgentOperation" as const,
  input: z.object({
    toolCallId: z.string(),
    scope: z.enum(["clean-only", "all"]),
  }),
  output: z.object({ undoneCount: z.number(), skippedCount: z.number() }),
};
